import {useLogger, useState} from '#imports';

type SessionReplay = typeof import('@amplitude/session-replay-browser');

export function useAmplitudeSessionReplayLoader() {
    const logger = useLogger();
    const sessionReplay = useState<SessionReplay | undefined>('amplitude-session-replay', () => undefined);
    const loading = useState<Promise<SessionReplay | undefined> | undefined>('amplitude-session-replay-loading', () => undefined);

    async function loadSessionReplay(): Promise<SessionReplay | undefined> {
        if (sessionReplay.value) {
            return sessionReplay.value;
        }

        if (loading.value) {
            return loading.value;
        }

        loading.value = (async () => {
            try {
                const mod = await import('@amplitude/session-replay-browser');
                sessionReplay.value = mod;
                return mod;
            } catch (error) {
                logger.error('Error loading Amplitude Session Replay SDK', error);
                return undefined;
            } finally {
                loading.value = undefined;
            }
        })();

        return loading.value;
    }

    return {
        loadSessionReplay,
        sessionReplay,
    };
}
